<template>
  <div id="main">
    <div class="top">
      <img
        src="https://i.tmuyun.com/webpic/W0202204/W020220413/W020220413510914812592.png"
        alt=""
      />
    </div>
    <div class="contents">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive">
          <!-- 这里是会被缓存的视图组件，比如 Home！ -->
        </router-view>
      </keep-alive>

      <router-view v-if="!$route.meta.keepAlive">
        <!-- 这里是不被缓存的视图组件，比如 Edit！ -->
      </router-view>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.initShareConfig();
  },
  methods: {
    initShareConfig() {
      let CP = window.CP;
      CP.setShare({
        completed: function (data) {
          // data > {success:'1'}
        },
        cpIncompatible: function () {
          CP.tools.writelog("", "此环境不支持此方法");
        },
        title: "城北街道，家风文明“五美”打卡活动",
        shareTo: "Timeline",
        link: window.location.origin + '/jfwm',
        imgUrl:
          "https://i.tmuyun.com/webpic/W0202203/W020220328/W020220328538619829620.jpg",
        shareSummary: "城北街道，家风文明“五美”打卡活动",
        id: "",
        type: "",
        datatype: "",
        dataUrl: "",
        shareUrlScheme: "",
        success: function () {
          CP.tools.writelog("set_share", "分享成功");
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
#main {
  background-image: url("https://i.tmuyun.com/webpic/W0202203/W020220328/W020220328554726181751.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
  min-height: 100vh;
}

.top {
  text-align: center;
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  img {
    width: 80vw;
  }
}

.contents {
  height: 60vh;
}
</style>
